(function() {
  if (window.__CE_CUSTOM_LIQUID_EN__) {
    if (typeof window.__CE_CUSTOM_LIQUID_EN__.scan === 'function') window.__CE_CUSTOM_LIQUID_EN__.scan();
    return;
  }

  const DICT = window.__CE_CL_EN_DICT__ || {};
  const SKIP = new Set(['SCRIPT','STYLE','NOSCRIPT','TEMPLATE','CODE','PRE']);
  const ATTRS = ['alt','aria-label','title','placeholder','value'];

  function clean(value) {
    return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function dynamic(value) {
    const text = clean(value);
    let match = text.match(/^Plus que\s+(.+?)\s+pour la livraison offerte$/i);
    if (match) return `Only ${match[1]} left for free shipping`;
    match = text.match(/^Plus que\s+(.+?)€\s+pour la livraison offerte$/i);
    if (match) return `Only €${match[1]} left for free shipping`;
    return null;
  }

  function translated(value) {
    const text = clean(value);
    if (!text) return null;
    if (Object.prototype.hasOwnProperty.call(DICT, text)) return DICT[text];
    return dynamic(text);
  }

  function preserveSpacing(original, replacement) {
    const lead = (String(original).match(/^\s*/) || [''])[0];
    const tail = (String(original).match(/\s*$/) || [''])[0];
    return lead + replacement + tail;
  }

  function translateText(node) {
    if (!node || !node.parentElement || SKIP.has(node.parentElement.tagName)) return;
    const result = translated(node.nodeValue);
    if (result !== null && clean(node.nodeValue) !== result) node.nodeValue = preserveSpacing(node.nodeValue, result);
  }

  function translateAttributes(el) {
    if (!el || el.nodeType !== 1 || SKIP.has(el.tagName)) return;
    ATTRS.forEach(function(attr) {
      if (!el.hasAttribute(attr)) return;
      const current = el.getAttribute(attr);
      const result = translated(current);
      if (result !== null && current !== result) el.setAttribute(attr, result);
    });
  }

  function translateRoot(root) {
    if (!root || root.nodeType !== 1) return;
    translateAttributes(root);
    root.querySelectorAll('*').forEach(translateAttributes);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateText);
  }

  function scan(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    if (base.matches && base.matches('[data-ce-custom-liquid]')) translateRoot(base);
    base.querySelectorAll('[data-ce-custom-liquid]').forEach(translateRoot);
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'characterData') {
        const parent = mutation.target.parentElement;
        if (parent && parent.closest('[data-ce-custom-liquid]')) translateText(mutation.target);
        return;
      }
      if (mutation.type === 'attributes') {
        const el = mutation.target;
        if (el.closest && el.closest('[data-ce-custom-liquid]')) translateAttributes(el);
        return;
      }
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 3) {
          const parent = node.parentElement;
          if (parent && parent.closest('[data-ce-custom-liquid]')) translateText(node);
        } else if (node.nodeType === 1) {
          const root = node.matches('[data-ce-custom-liquid]') ? node : node.closest('[data-ce-custom-liquid]');
          if (root) translateRoot(root);
        }
      });
    });
  });

  window.__CE_CUSTOM_LIQUID_EN__ = { scan: scan };

  function start() {
    scan(document);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRS
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', function(event) { scan(event.target); });
})();
